import SharedView, { type SharedViewSlide } from "../../sharedComponents/viewIndex"
import DownloadView from "./downloadView"

const DoduThemeIndex = () => {
    const slides: SharedViewSlide[] = [
        {
            id: "spring",
            label: <>SPRING CAMPUS WITH <span className="text-[#2f6c5c]">DODU</span></>,
            viewComponent: <DownloadView type="spring" />,
            isAvailable: true
        },
        {
            id: "summer",
            label: <>SUMMER CAMPUS WITH <span className="text-[#2f6c5c]">DODU</span></>,
            viewComponent: <DownloadView type="summer" />,
            isAvailable: false
        },
        {
            id: "reveal-autumn",
            label: <>AUTUMN CAMPUS WITH <span className="text-[#2f6c5c]">DODU</span></>,
            viewComponent: <DownloadView type="autumn" />,
            isAvailable: false
        },
        {
            id: "reveal-winter",
            label: <>WINTER CAMPUS WITH <span className="text-[#2f6c5c]">DODU</span></>,
            viewComponent: <DownloadView type="winter" />,
            isAvailable: false
        },
        {
            id: "reveal-night",
            label: <>NIGHT CAMPUS WITH <span className="text-[#2f6c5c]">DODU</span></>,
            viewComponent: <DownloadView type="night" />,
            isAvailable: false
        }
    ]

    return <SharedView slides={slides} />
}

export default DoduThemeIndex
